export enum InvoicesRoutePathsEnum {
  INVOICES = 'invoices',
}
